import SliderService from './SliderService';
export default SliderService;
